import CustomButton from 'components/Buttons/CustomButton'
import { ArrowDownLeft, ArrowLeft, Phone } from 'react-feather'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Card, CardBody, Modal } from 'reactstrap'

const ModalPendingTopup = ({ isOpen, toggle }) => {
  const publicVersion = useSelector((s) => s.publicVersion)
  const navigate = useNavigate()

  return (
    <Modal
      centered
      size="sm"
      isOpen={isOpen}
      toggle={toggle}
      data-testid="payment-pending-modal"
    >
      <Card className="border-0 shadow-sm">
        <CardBody className="d-flex flex-column align-items-center">
          <p className="fw-semibold">Transaksi Diproses</p>
          <p className="small">
            Transaksi Anda sedang dalam proses. Kami akan memberi notifikasi
            apabila proses sudah selesai.
          </p>
          <CustomButton
            testId="payment-pending-contact-cs-button"
            block
            outline
            color="primary"
            onClick={() =>
              window.open(
                `https://wa.me/${publicVersion?.data?.csNumber}`,
                '_blank',
              )
            }
          >
            <Phone size={17} /> <span> Hubungi CS</span>
          </CustomButton>
          <CustomButton
            testId="payment-pending-home-button"
            block
            color="primary"
            className="mt-2"
            onClick={() => navigate('/')}
          >
            <ArrowLeft size={17} /> <span> Kembali ke Beranda</span>
          </CustomButton>
        </CardBody>
      </Card>
    </Modal>
  )
}

export default ModalPendingTopup
